import inSection from "./in-section.util";

// Each page also exists under /scheduling-v3, where the section resolves for
// someone who chose the new scheduler.
export const SCHEDULING_DESTINATIONS = inSection("/scheduling", [
  { to: "view", label: "View Schedule" },
  { to: "day-sheet", label: "Day Sheet" },
  {
    to: "room-traffic",
    label: "Room Traffic",
    when: ({ currentClinic }) =>
      Boolean(currentClinic?.practice?.use_room_traffic)
  }
]);
